export const checkNull = (data) => {
	return data !== undefined ? data : null;
};
